<template>
  <div>
    <Alert :show.sync="showNewUserAlert" @close="onNewUserClose">
      <div class="newuser-tips">
        您已注册成功，初始密码为：{{
          defaultPassword
        }}，请及时前往个人中心更换密码
      </div>
    </Alert>
    <div v-if="dialogVisible">
      <el-dialog
        :close-on-click-modal="false"
        :title="title"
        :visible.sync="dialogVisible"
        @close="handleCancel"
        class="loginModal"
        width="560px"
      >
        <!-- :show-close="false"-->
        <div class="type-title" v-if="type == 'register'">
          <div class="back" @click="type = 'passwordLogin'">返回</div>
          <span :class="{ current: type == 'register' }">注册账号</span>
        </div>
        <div class="type-title" v-if="type == 'findPassword'">
          <span :class="{ current: type == 'findPassword' }">忘记密码</span>
        </div>
        <div
          class="type-title"
          v-if="type == 'passwordLogin' || type == 'codeLogin'"
        >
          <!-- <span
            :class="{ current: type == 'codeLogin' }"
            @click="
              type = 'codeLogin';
              resetForm('loginInfo');
            "
          >
            验证码登录
          </span> -->
          <span
            :class="{ current: type == 'passwordLogin' }"
            @click="
              type = 'passwordLogin';
              resetForm('loginInfo');
            "
          >
            密码登录
          </span>
        </div>
        <el-form
          class="el_form"
          :class="{ form_code_login: type == 'codeLogin' }"
          v-show="type == 'passwordLogin' || type == 'codeLogin'"
          :model="loginInfo"
          :rules="rules"
          ref="loginInfo"
          :hide-required-asterisk="true"
          :validate-on-rule-change="false"
        >
          <el-form-item prop="phone" class="phone">
            <div class="label">手机号</div>
            <el-input
              placeholder="请输入手机号"
              v-model="loginInfo.phone"
              @focus="onInputFocus"
              @blur="onInputBlur"
              :maxlength="11"
              @input="handleInput" 

            >
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item
            prop="code"
            v-if="type == 'codeLogin'"
            class="el-form-item-code"
          >
            <div class="label">验证码</div>
            <el-input
              placeholder="请输入验证码"
              v-model="loginInfo.code"
              @keydown.native.enter="submitForm()"
              @focus="onInputFocus"
              @blur="onInputBlur"
              maxlength="6"
            ></el-input>
            <el-button
              class="btn-code"
              :disabled="codeBtn"
              :class="{ 'is-disabled': codeBtn }"
              type="text"
              @click="get_code('loginInfo', 'login', loginInfo.phone)"
            >
              {{ codeBtnInfo }}
            </el-button>
          </el-form-item>

          <el-form-item
            prop="password"
            class="el-form-item-password"
            v-if="type == 'passwordLogin'"
          >
            <div class="label">密码</div>
            <el-password
              placeholder="请输入密码"
              v-model="loginInfo.password"
              autocomplete="new-password"
              @enter="submitForm()"
            ></el-password>
          </el-form-item>
          <el-form-item
            v-if="pcLoginCount > 3 && img_code"
            prop="captcha"
            class="img_item_code"
          >
            <el-input
              placeholder="请输入图形验证码"
              v-model="loginInfo.captcha"
              @keydown.native.enter="submitForm()"
              @focus="onInputFocus"
              @blur="onInputBlur"
              maxlength="6"
            ></el-input>
            <img
              :src="img_code"
              class="img_code"
              @click="getImgCode"
              title="点击切换验证码"
            />
            <img
              class="img-refresh"
              src="@/assets/images/common/refresh@2x.png"
              @click="getImgCode"
            />
            <a class="lnk-refresh" @click="getImgCode">刷新</a>
          </el-form-item>
          <p v-if="type == 'codeLogin'" class="auto_login_msg">
            未注册的手机号登录时自动注册
          </p>
          <el-form-item class="el_submit">
            <div class="btn-login" @click="submitForm()">登录</div>
          </el-form-item>
          <el-form-item class="forget_item">
            <div
              class="forget_password"
              v-if="type == 'passwordLogin'"
              @click="forget_password"
            >
              忘记密码?
            </div>
            <!-- <div
              class="forget_register"
              v-if="store.state.commonSetting.allow_student_register == 1"
              @click="register_form"
            >
              没有账号，去注册
            </div> -->
          </el-form-item>
          <el-form-item class="other_login">
            <div class="other">
              <div
                class="title"
                v-if="
                  oauthConfig.wxLogin.is_available == 1 ||
                  oauthConfig.qqLogin.is_available == 1
                "
              >
                第三方登录
              </div>
              <div class="set">
                <img
                  src="@/assets/images/login/wechat@2x.png"
                  class="wechat"
                  @click="wx_login_saas()"
                  v-if="
                    oauthConfig.wxLogin.is_available == 1 &&
                    commonSetting.saas_enable == 1
                  "
                />
                <img
                  src="@/assets/images/login/wechat@2x.png"
                  class="wechat"
                  @click="wx_login(1)"
                  v-if="
                    oauthConfig.wxLogin.is_available == 1 &&
                    commonSetting.saas_enable != 1
                  "
                />
                <img
                  src="@/assets/images/login/qq@2x.png"
                  class="qq"
                  @click="qq_login()"
                  v-if="
                    oauthConfig.qqLogin.is_available == 1 &&
                    commonSetting.is_force_bind_wx != 1
                  "
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item class="register_contract center">
            <span>登录即代表您同意</span>
            <a
              href="javascript:void(0)"
              @click="openContract('user_register_contract')"
            >
              《用户注册协议》
            </a>
            <span>和</span>
            <a
              href="javascript:void(0)"
              @click="openContract('user_protect_contract')"
            >
              《隐私政策》
            </a>
          </el-form-item>
        </el-form>
        <el-form
          v-show="type == 'findPassword'"
          :model="otherLoginInfo"
          :rules="otherLoginRules"
          ref="findPasswordInfo"
          :hide-required-asterisk="true"
          class="find-password"
          :validate-on-rule-change="false"
        >
          <!--找回密码-->
          <el-form-item prop="phone" class="phone">
            <div class="label">
              手机号
              <span style="margin-left: 5px">仅支持通过手机号码重置密码</span>
            </div>
            <el-input
              placeholder="请输入手机号"
              v-model="otherLoginInfo.phone"
              @focus="onInputFocus"
              @blur="onInputBlur"
            >
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item class="el-form-item-code" prop="code">
            <div class="label">验证码</div>
            <el-input
              placeholder="请输入验证码"
              v-model="otherLoginInfo.code"
              @focus="onInputFocus"
              @blur="onInputBlur"
            ></el-input>
            <el-button
              class="btn-code"
              :disabled="codeBtn"
              type="text"
              @click="
                get_code(
                  'findPasswordInfo',
                  'getPassword',
                  otherLoginInfo.phone,
                )
              "
            >
              {{ codeBtnInfo }}
            </el-button>
          </el-form-item>
          <el-form-item class="el-form-item-password" prop="password">
            <div class="label">密码</div>
            <el-password v-model="otherLoginInfo.password"></el-password>
          </el-form-item>
          <el-form-item class="el_submit">
            <div class="btn-login" @click="findSubmitForm()">确定</div>
            <div class="now-login" @click="nowLogin">登录</div>
          </el-form-item>
        </el-form>
        <el-form
          v-show="type == 'register'"
          :model="registerInfo"
          :rules="registerRules"
          ref="registerInfo"
          id="registerRules"
          class="registerInfo"
          label-width="85px"
          :validate-on-rule-change="false"
        >
          <!--注册-->
          <el-form-item label="姓名" prop="nickname">
            <el-input
              placeholder="请输入姓名"
              v-model="registerInfo.nickname"
              @focus="onInputFocus"
              maxlength="15"
              @blur="onInputBlur"
            ></el-input>
          </el-form-item>
          <template
            v-if="
              store.state.commonSetting.bind_phone == 1 ||
              store.state.commonSetting.register_method == 2
            "
          >
            <el-form-item prop="phone" label="手机号">
              <el-input
                placeholder="请输入手机号"
                v-model="registerInfo.phone"
                @focus="onInputFocus"
                @blur="onInputBlur"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input
                placeholder="请输入验证码"
                v-model="registerInfo.code"
                @focus="onInputFocus"
                @blur="onInputBlur"
              ></el-input>
              <el-button
                class="btn-code"
                :disabled="codeBtn"
                type="text"
                @click="
                  get_code('registerInfo', 'register', registerInfo.phone)
                "
              >
                {{ codeBtnInfo }}
              </el-button>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="手机号">
              <el-input
                placeholder="请输入手机号"
                v-model="registerInfo.phone"
                @focus="onInputFocus"
                @blur="onInputBlur"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <el-input
                placeholder="请输入验证码"
                v-model="registerInfo.code"
                @focus="onInputFocus"
                @blur="onInputBlur"
              ></el-input>
              <el-button
                class="btn-code"
                :disabled="codeBtn"
                type="text"
                @click="
                  get_code('registerInfo', 'register', registerInfo.phone)
                "
              >
                {{ codeBtnInfo }}
              </el-button>
            </el-form-item>
          </template>
          <el-form-item
            label="用户名"
            prop="login_name"
            v-if="store.state.commonSetting.register_method == 1"
          >
            <el-input
              placeholder="请输入用户名"
              maxlength="15"
              v-model="registerInfo.login_name"
              @focus="onInputFocus"
              @blur="onInputBlur"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名" v-else>
            <el-input
              placeholder="请输入用户名"
              v-model="registerInfo.login_name"
              @focus="onInputFocus"
              maxlength="15"
              @blur="onInputBlur"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-password v-model="registerInfo.password"></el-password>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirm_password">
            <el-password v-model="registerInfo.confirm_password"></el-password>
          </el-form-item>
          <el-form-item class="el_submit">
            <div class="btn-login" @click="registerForm()">注册并登录</div>
          </el-form-item>
          <el-form-item class="register_contract center">
            <span>登录即代表您同意</span>
            <a
              href="javascript:void(0)"
              @click="openContract('user_register_contract')"
            >
              《用户注册协议》
            </a>
            <span>和</span>
            <a
              href="javascript:void(0)"
              @click="openContract('user_protect_contract')"
            >
              《隐私政策》
            </a>
          </el-form-item>
        </el-form>
        <!--
       {{ dialogVisible }}=== {{ title }}===
      {{ type }}
      <template v-slot:footer>
        <el-button type="primary" @click="handleCancel">111</el-button>
        <el-button type="primary" @click="handleConfirm">2222</el-button>
      </template>
     -->
        <div v-show="type == 'wxLogin'" class="wx-code-box">
          <p class="title">微信{{ is_bind_wx == 1 ? "绑定" : "登录" }}</p>
          <div id="wx_login_id"></div>
          <p class="msg">
            请使用微信扫码{{ is_bind_wx == 1 ? "绑定" : "登录" }}
          </p>
          <p @click="type = 'passwordLogin'" class="back">
            <img src="~@/assets/images/login/login_code_back.png" />
            返回
          </p>
        </div>
      </el-dialog>
      <SelectSchoolDlg
        ref="selectSchool"
        :visible.sync="showSelectSchool"
        @on-select="onSelectSchool"
      ></SelectSchoolDlg>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alert.vue";
import { Encrypt } from "@/utils/encryption.js";
import SelectSchoolDlg from "@/modules/stu/components/SelectSchoolDlg";
export default {
  name: "LoginModal",
  components: {
    SelectSchoolDlg,
    Alert,
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      // if (this.type == "passwordLogin") {
      //   if (value === "") {
      //     callback(new Error("请输入手机号码"));
      //   } else {
      //     callback();
      //   }
      // } else {
        let reg = /^1\d{10}$/;
        if (value === "") {
          callback(new Error("请输入手机号码"));
        } else if (value.length < 11) {
          callback(new Error("手机号码不足11位，请重新输入！"));
        } else if (reg.test(value) === false) {
          callback(new Error("请输入正确的11位号码！"));
        } else {
          callback();
        }
      //}
    };
    let imgCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("图形验证码不能为空"));
      } else if (value.length < 4) {
        callback(new Error("图形验证码不足4位，请重新输入！"));
      } else {
        callback();
      }
    };
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入短信验证码"));
      } else if (value.length < 6) {
        callback(new Error("短信验证码不足6位，请重新输入！"));
      } else {
        callback();
      }
    };
    let validateRePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (
        this.registerInfo.confirm_password !== this.registerInfo.password
      ) {
        callback(new Error("两次输入密码不一致"));
      } else if (this.$pub.guarantee(1, this.registerInfo.confirm_password)) {
        if (
          this.$pub.guarantee(1, this.registerInfo.confirm_password) == true
        ) {
          callback();
        } else {
          callback(
            new Error(
              this.$pub.guarantee(1, this.registerInfo.confirm_password),
            ),
          );
        }
      } else {
        callback();
      }
    };
    let RecoverPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (this.$pub.guarantee(1, value)) {
        if (this.$pub.guarantee(1, value) == true) {
          callback();
        } else {
          callback(new Error(this.$pub.guarantee(1, value)));
        }
      } else {
        callback();
      }
    };
    return {
      showNewUserAlert: false,
      is_bind_wx: 0,
      pcLoginCount: 0,
      img_code: "",
      codeBtn: false,
      otherLogin: false,
      findPassword: false,
      codeBtnInfo: "获取验证码",
      loginInfo: {
        //验证码或者密码登录
        phone: "",
        password: "",
        code: "",
        captcha: "",
        key: "",
      },
      rules: {
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            validator: imgCode,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: "blur",
          },
        ],
      },
      registerInfo: {
        //注册
        password: "",
        confirm_password: "",
        public_school_org_rule: "",
        public_school_org_rule_arr: [],
        nickname: "",
        login_name: "",
        phone: "",
        code: "",
      },
      registerRules: {
        public_school_org_rule: [
          {
            required: true,
            message: "请输入所在班级",
            trigger: "blur",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        login_name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        confirm_password: [
          {
            required: true,
            validator: validateRePass,
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: "blur",
          },
        ],
      },
      otherLoginInfo: {
        //找回密码
        phone: "",
        code: "",
        password: "",
      },
      otherLoginRules: {
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            validator: imgCode,
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: RecoverPassword,
            trigger: "blur",
          },
        ],
      },
      openId: "",
      otherType: 1,
      oauthConfig: { qqLogin: {}, wxLogin: {} },
      showSelectSchool: false,
      newUserResolve: null,
      defaultPassword: "",
      wxLogin: false,
      dialogVisible: false, //控制显隐
      title: "", //标题
      type: "passwordLogin", //register
      store: "",
      optionProps: {
        value: "classify_rule",
      },
      commonSetting: {},
      request:{}
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.pcLoginCount = sessionStorage.pcLoginCount;
        if (sessionStorage.pcLoginCount > 3) {
          this.getImgCode();
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {
    config() {
      return this.store ? this.store.state.webConfig : null;
    },
  },
  async created() {
    // const pass = Encrypt("111");
    // console.log("明文", "111");
    // console.log("加密后", pass);
    this.pcLoginCount = sessionStorage.pcLoginCount;
    if (sessionStorage.pcLoginCount > 3) {
      this.getImgCode();
    }
    this.oauthConfig = await this.$http.put(
      "/api/app/systemSet/available/oauthConfig",
    );
    let res = await this.$http.get("/api/app/config/common_setting");
    this.commonSetting = res.common_setting;

    sessionStorage.setItem('login-phone',this.loginInfo.phone)
  },
  methods: {
    onNewUserClose() {
      this.newUserResolve();
    },
    async handleNewUser(data) {
      await this.store.dispatch("getSchoolInfo");

      return new Promise(resolve => {
        if (data.first_login == 1) {
          this.defaultPassword = data.default_pass;
          this.newUserResolve = resolve;
          this.showNewUserAlert = true;
        } else {
          resolve();
        }
      });
    },
    handleChange(value) {
      this.registerInfo.public_school_org_rule = value[value.length - 1];
    },
    goTo() {
      this.store.dispatch("refreshMessageState");
      this.handleConfirm();
    },
    async getFirstLogin(mobile){
      const res = await this.$http.get("/api/app/first_login",{mobile})

      return res.is_collect==2?true:false
    },
    async login() {
      let that = this;
      // let request = {
      //   mobile: this.loginInfo.phone,
      //   type: this.type == "codeLogin" ? 2 : 1,
      //   client: 1,
      // };
      this.request.mobile = this.loginInfo.phone
      this.request.type = this.type == "codeLogin" ? 2 : 1
      this.request.client = 1

      this.request.captcha = this.loginInfo.captcha;

      if (this.type == "codeLogin") {
        this.request.sms_code = this.loginInfo.code;
      } else {
        this.request.password = Encrypt(this.loginInfo.password);
      }
      if (!sessionStorage.pcLoginCount) {
        sessionStorage.pcLoginCount = 0;
      }
      sessionStorage.pcLoginCount++;
      this.pcLoginCount = sessionStorage.pcLoginCount;


      try {
        console.log(55555,this.request.key)
        let data = await this.$http.post("/api/app/login", this.request);

        data.need_collect_data = await this.getFirstLogin(this.loginInfo.phone)


        if (data.is_force_bind_wx == 1 && data.wx_openid == "") {
          this.wx_login(2);
          this.is_bind_wx = 1;
          return;
        }
        await this.handleNewUser(data);
        sessionStorage.removeItem("pcLoginCount");
        if (data.need_collect_data) {
  
          sessionStorage.setItem("pr_userId", data.id);
          sessionStorage.setItem("pr_webToken", data.remember_token);
          window.location.href = "/pc/regist-information";
        } else {
          this.store.commit("login", data.remember_token);
          await this.store.dispatch("get_user_info");
          await this.$success("登录成功");
          this.goTo();
        }
        
      } catch (error) {
        if (sessionStorage.pcLoginCount > 3) {
          this.getImgCode();
        }

      }
      
    },
    async registerlogin() {
      let request = {
        public_school_org_rule: this.registerInfo.public_school_org_rule,
        nickname: this.registerInfo.nickname,
        login_name: this.registerInfo.login_name,
        sms_code: this.registerInfo.code,
        password: Encrypt(this.registerInfo.password),
        confirm_password: Encrypt(this.registerInfo.confirm_password),
        mobile: this.registerInfo.phone,
        type: 1, //写死密码注册
        client: 1,
      };
      let data = await this.$http.post("/api/app/register", request);
      sessionStorage.removeItem("pcLoginCount");

      data.need_collect_data = await this.getFirstLogin(this.registerInfo.phone)

      if (data.need_collect_data) {
        sessionStorage.setItem("pr_userId", data.id);
        sessionStorage.setItem("pr_webToken", data.remember_token);
        window.location.href = "/pc/regist-information";
      } else {
        this.store.commit("login", data.remember_token);
        await this.store.dispatch("get_user_info");
        await this.$success("注册且登录成功");
        this.goTo();
      }
    },
    // async checkUser(mobile) {
    //   const data = await this.$http.get(`/api/app/checkUser/${mobile}`);
    //   return data;
    // },
    submitForm() {
      this.$refs["loginInfo"].validate(async valid => {
        if (!valid) return;
        // 密码登陆不检测用户
        // if (this.type == "passwordLogin") {
        //   await this.login();
        // } else {
        //   const result = await this.checkUser(this.loginInfo.phone);
        //   if (result.is_new_user == 1) {
        //     if (this.$refs.selectSchool.isSingleSchool()) {
        //       this.onSelectSchool(this.$refs.selectSchool.getSingleSchoolID());
        //     } else {
        //       this.showSelectSchool = true;
        //     }
        //   } else {
        //     await this.login();
        //   }
        // }
        await this.login();
      });
    },
    async otherLoginFunc() {
      let data = await this.$http.post("/api/app/login", {
        type: this.$route.query.state,
        mobile: this.otherLoginInfo.phone,
        sms_code: this.otherLoginInfo.code,
        password: Encrypt(this.otherLoginInfo.password),
        unionid: this.openId,
      });
      if (data.is_force_bind_wx == 1 && data.wx_openid == "") {
        this.wx_login(2);
        this.is_bind_wx = 1;
        return;
      }
      await this.handleNewUser(data);
      sessionStorage.removeItem("pcLoginCount");

      data.need_collect_data = await this.getFirstLogin(this.otherLoginInfo.phone)

      if (data.need_collect_data) {
        sessionStorage.setItem("pr_webToken", data.remember_token);
        window.location.href = "/pc/regist-information";
      } else {
        this.store.commit("login", data.remember_token);
        await this.store.dispatch("get_user_info");
        await this.$success("登录成功");
        this.goTo();
      }
    },
    onSelectSchool(school_id) {
      this.store.commit("clearSchoolInfo");
      this.store.commit("setSchoolID", school_id);
      if (this.type == "findPassword") {
        this.otherLoginFunc();
      } else if (this.type == "register") {
        this.registerlogin();
      } else {
        this.login();
      }
    },
    registerForm() {
      //注册
      this.$refs["registerInfo"].validate(async valid => {
        if (!valid) return;
        await this.registerlogin();
      });
    },
    findSubmitForm() {
      this.$refs["findPasswordInfo"].validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$http.post("/api/app/password", {
          mobile: this.otherLoginInfo.phone,
          password: Encrypt(this.otherLoginInfo.password),
          sms_code: this.otherLoginInfo.code,
        });
        await this.$info("密码重置成功，请登录！");
        this.type = "passwordLogin";
      });
    },
    qq_login() {
      let url = location.protocol + "//" + location.host;
      document.location =
        "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=" +
        this.oauthConfig.qqLogin.appId +
        "&redirect_uri=" +
        url +
        "/login&state=3";
    },
    wx_login(type) {
      const that = this;
      let url = location.protocol + "//" + location.host + "/login";
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
      const wxElement = document.body.appendChild(s);
      wxElement.onload = function () {
        let obj = new window.WxLogin({
          id: "wx_login_id", // 需要显示的容器id
          appid: that.oauthConfig.wxLogin.appId, // 公众号appid wx*******
          scope: "snsapi_login", // 网页默认即可
          redirect_uri: encodeURIComponent(
            url + (type == 2 ? "?mobile=" + that.loginInfo.phone : ""),
          ), // 授权成功后回调的url
          state: 4, // 可设置为简单的随机数加session用来校验
          style: "black", // 提供"black"、"white"可选。二维码的样式
          href:
            "data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3gge3dpZHRoOjIxMnB4O2hlaWdodDoyMTJweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMTJweDtoZWlnaHQ6MjEycHg7bWFyZ2luOiAwO2JvcmRlcjogbm9uZX0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg==", // 外部css文件url，需要https
        });
        console.log(obj);
        that.type = "wxLogin";
      };
    },
    wx_login_saas() {
      const that = this;
      let url = location.protocol + "//" + location.host + "/login";
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
      const wxElement = document.body.appendChild(s);
      wxElement.onload = function () {
        let obj = new window.WxLogin({
          id: "wx_login_id", // 需要显示的容器id
          appid: that.oauthConfig.wxLogin.appId, // 公众号appid wx*******
          scope: "snsapi_login", // 网页默认即可
          redirect_uri: encodeURIComponent(
            that.config.login_auth_url +
              "/login-middle?saas_redirect_url=" +
              url,
          ), // 授权成功后回调的url
          state: 4, // 可设置为简单的随机数加session用来校验
          style: "black", // 提供"black"、"white"可选。二维码的样式
          href:
            "data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3gge3dpZHRoOjIxMnB4O2hlaWdodDoyMTJweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMTJweDtoZWlnaHQ6MjEycHg7bWFyZ2luOiAwO2JvcmRlcjogbm9uZX0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg==", // 外部css文件url，需要https
        });
        console.log(obj);
        that.type = "wxLogin";
      };
    },
    nowLogin() {
      this.type = "passwordLogin";
      this.resetForm("loginInfo");
    },
    forget_password() {
      this.type = "findPassword";
      this.resetForm("findPasswordInfo");
      this.registerInfo.phone = sessionStorage.getItem('login-phone')
    },
    register_form() {
      this.type = "register";
      this.resetForm("registerInfo");
    },
    onInputFocus($event) {
      let target = $event.target;
      target.parentElement.classList.add("focus");
    },
    onInputBlur($event) {
      let target = $event.target;
      target.parentElement.classList.remove("focus");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$nextTick(()=>{
        this.loginInfo.phone = sessionStorage.getItem('login-phone')
      })
    },
    handleInput(){
        sessionStorage.setItem('login-phone',this.loginInfo.phone)
    },
    openContract(key) {
      window.open("/pc/contract/?key=" + key);
    },
    getImgCode() {
      this.$http
        .get("/api/app/captcha", {})
        .then(res => {
          this.img_code = res.img;
          this.loginInfo.key = res.key;
          this.request.key = res.key;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async get_code(info, type, mobile) {
      console.log(type);
      console.log(mobile);
      if (this.$pub.isText(mobile) == "") {
        this.$error("请输入手机号...");
        return;
      }
      if (this.codeBtn) {
        this.$error("不可重复发送...");
        return;
      }
      console.log(this.$refs[info]);
      await this.$services.CodeService.sendSmsCode(mobile, type);
      let count = 60;
      this.codeBtn = true;
      let sendTimer = setInterval(() => {
        count--;
        this.codeBtnInfo = "重新发送" + count;
        if (count < 0) {
          this.codeBtn = false;
          clearInterval(sendTimer);
          this.codeBtnInfo = "获取验证码";
        }
      }, 1000);
    },
    //以上方法原来登录逻辑
    handleConfirm() {
      this.dialogVisible = false;
      this.store.commit("setCouponDlg", {
        show: true,
        type: 2,
      });
      if (this.onOK) {
        this.onOK(true);
      }
      location.reload();
    },
    handleCancel() {
      //this.store.commit("login", 333333);
      //console.log(this.store.state.token);
      this.dialogVisible = false;
      sessionStorage.removeItem("login-phone");
      if (this.onCancel) {
        this.onCancel();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.type-title {
  left: 0px;
  top: 24px;
  width: 100%;
  display: flex;
  position: absolute;
  z-index: 1;
  justify-content: center;
  height: 50px;
  background: #fff;
  .back {
    position: absolute;
    left: 10px;
    top: 0px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    padding-left: 30px !important;
    background: url(~@/assets/images/login/Frame2x.png) no-repeat 10px center;
    background-size: 16px 16px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    color: #333333;
    &:hover {
      color: $primary-color;
      background: url(~@/assets/images/login/login_code_back.png) no-repeat 10px
        center;
      background-size: 16px 16px;
    }
  }
  span {
    color: #999;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC-600;
    font-weight: 600;
    display: inline-block;
    cursor: pointer;
    position: relative;
    height: 40px;
    line-height: 40px;
    margin: 0px 40px;

    &.current {
      color: #333;
      &::after {
        content: "";
        position: absolute;
        width: 47px;
        height: 4px;
        background: url(~@/assets/images/login/current.png) no-repeat bottom
          center;
        background-size: 47px 4px;
        bottom: 0px;
        left: 50%;
        margin-left: -23px;
      }
    }
  }
}
/deep/ {
  .registerInfo {
    width: 100%;
    // display: table;
    margin-top: 10px;
    .el-form-item {
      margin-bottom: 30px;
    }
    .btn-code {
      top: 0px !important;
      transform: none !important;
    }
    .el-input__inner {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
    .el-form-item__label {
      line-height: 48px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #333333;
    }
  }
  .el_form {
    width: 100%;
    display: table;
  }

  .el-form-item {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }

    &.set-pass {
      margin-bottom: 60px;

      button {
        height: 50px;
        width: 100%;
        background-color: #f4f4f4;
        border: none;
      }
    }

    .btn-code {
      color: $primary-color;
      line-height: 48px;
      position: absolute;
      padding: 0;
      top: 15px;
      right: 0px;
      padding-right: 10px;
      transform: translateY(50%);

      &.is-disabled {
        color: #bfbfbf;
      }
    }
    .label {
      height: 32px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 32px;
      margin-bottom: 10px;
      span {
        color: #999;
        font-size: 14px;
      }
    }

    .el-input-group__append {
      background-color: transparent;
      border-color: #ededed;
    }
    &.img_item_code {
      .el-form-item__content {
        position: relative;
        .img_code {
          float: left;
          height: 48px;
          cursor: pointer;
          margin-right: 10px;
          margin-left: 10px;
        }
        .img-refresh {
          float: left;
          width: 16px;
          height: 16px;
          margin-top: 15px;
          cursor: pointer;
        }
        .lnk-refresh {
          float: left;
          line-height: 48px;
          padding: 0px 3px;
          cursor: pointer;
        }
        .el-input {
          float: left;
          width: 200px;
          .el-input__inner {
            padding-left: 35px !important;
            background: url(~@/assets/images/login/login_01.png) no-repeat 10px
              center;
            background-size: 20px 20px;
          }
        }
      }
    }
    &.el-form-item-code {
      .el-form-item__content {
        position: relative;
        .el-input {
          position: relative;
          .el-input__inner {
            padding-left: 35px !important;
            background: url(~@/assets/images/login/login_01.png) no-repeat 10px
              center;
            background-size: 20px 20px;
          }
        }
      }
    }
    &.forget_item {
      .el-form-item__content {
        color: $primary-color;
        margin-bottom: 0;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #bb1c20;
        .forget_password {
          float: left;
          cursor: pointer;
        }
        .forget_register {
          float: right;
          cursor: pointer;
          padding-right: 20px !important;
          background: url(~@/assets/images/login/login_code_back2.png) no-repeat
            right center;
          background-size: 16px 16px;
        }
      }
    }
    &.el-form-item-password {
      .el-form-item__content {
        .el-input-group--append {
          .el-input__inner {
            padding-left: 35px !important;
            background: url(~@/assets/images/login/login_03.png) no-repeat 10px
              center;
            background-size: 20px 20px;
          }
        }
      }
    }
    &.el_submit {
      .el-form-item__content {
        margin-bottom: 0;
        .now-login {
          background: rgba(234, 98, 56, 0);
          border: 1px solid rgba(237, 237, 237, 1);
          border-radius: 5px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          text-align: center;
          cursor: pointer;
          margin-top: 10px;
        }
        .btn-login {
          width: 100%;
          background: $primary-color;
          border-radius: 5px;
          text-align: center;
          cursor: pointer;
          height: 48px;
          line-height: 48px;
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    &.register_contract {
      .el-form-item__content {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        text-align: center;
        color: #333333;
        line-height: 24px;
        a {
          color: $primary-color;
        }
      }
    }
    &.phone {
      .el-input-group__prepend {
        position: relative;
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 1;
        background-color: transparent;
        border-color: #ededed;
        background: url(~@/assets/images/login/login_012.png) no-repeat 10px
          center;
        background-size: 20px 20px;
        padding-left: 36px;
        padding-right: 0px !important;
        &::after {
          content: "";
          position: absolute;
          width: 1px;
          background-color: #000000;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .el-form-item__content {
        .el-input__inner {
          border-left: none;
          padding-left: 15px !important;
        }
      }
    }
    &.other_login {
      margin-bottom: 0;
    }
    .other {
      width: 100%;
      .title {
        text-align: center;
        color: rgba(153, 153, 153, 1);
        line-height: 1;
        background-image: url("~@/assets/images/login/other@2x.png");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% 1px;
      }
      .set {
        display: flex;
        justify-content: center;
        margin-top: 14px;
        img {
          margin: 0 12px;
          cursor: pointer;
          flex-shrink: 0;
          width: 48px;
        }
      }

      .contract {
        color: rgba(102, 102, 102, 1);
        line-height: 1;

        a {
          color: $primary-color;
        }
      }
    }
  }
  .el-form-item__content {
    margin-bottom: 10px;

    .el-input__inner {
      border: 1px solid #ededed;
      height: 48px;
      color: #333;
      transition: none;
      padding: 0;
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      padding-left: 30px;
      &::placeholder {
        color: #cccccc;
      }
    }

    .el-form-item__error {
      color: rgba(255, 45, 40, 1);
      line-height: 1;
      padding: 0;
      top: 110%;
    }

    .focus {
      .el-input-group__prepend,
      .el-input-group__append,
      .el-input__inner {
        border-color: $primary-color;
      }
    }
  }
  .auto_login_msg {
    margin: -19px 0 19px;
    font-size: 14px;
    color: #999;
  }
  button {
    font-weight: normal;
  }
  .wx-code-box {
    .title {
      margin-top: 3px;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 28px;
      color: #343434;
      line-height: 28px;
    }
    .msg {
      text-align: center;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 18px;
      color: #333;
      line-height: 18px;
    }
    .back {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      margin: 30px auto 0;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: $primary-color;
      cursor: pointer;
      img {
        width: 18px;
        height: 18px;
        margin-left: -5px;
      }
    }
    #wx_login_id {
      width: 212px;
      height: 212px;
      margin: 0 auto;
      iframe {
        width: 212px;
        height: 212px;
      }
    }
  }
}
</style>
<style scoped></style>
